
import React, { ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useOidcUserContext } from "../contexts/OidcUserContext";
import { fetchAuthentication, setAuthentication } from "../actions";
import { RootState } from "../store";

const OidcToReduxSync = ({ children }: { children: ReactNode }) => {
    const dispatch = useDispatch();
    const { oidcUser, signoutRedirect } = useOidcUserContext();
    const { access_token, forceLogout } = useSelector((state: RootState) => state.authentication);

    useEffect(() => {
        const access_token = oidcUser ? oidcUser.access_token : null;
        dispatch(setAuthentication({ access_token }));
    }, [oidcUser]);

    useEffect(() => {
        access_token && dispatch(fetchAuthentication());
    }, [access_token]);

    useEffect(() => {
        forceLogout && signoutRedirect();
    }, [forceLogout]);

    return <>{children}</>;
};

export default OidcToReduxSync;
